import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import api from '../api/axios';
import { ChevronLeft, Calendar, User, Share2 } from 'lucide-react';

function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(`/posts/${slug}`)
      .then(res => {
        setPost(res.data);
        setLoading(false);
      })
      .catch(() => {
        setPost(null);
        setLoading(false);
      });
  }, [slug]);

  if (loading) return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="w-10 h-10 border-2 border-slate-100 border-t-slate-900 animate-spin rounded-full" />
    </div>
  );

  if (!post) return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-white px-6">
      <h2 className="text-3xl font-serif italic text-slate-900 mb-4">Historia no encontrada</h2>
      <Link to="/blog" className="text-xs font-bold uppercase tracking-widest border-b-2 border-slate-900 pb-1">Volver al Editorial</Link>
    </div>
  );

  return (
    <article className="min-h-screen bg-white pb-24">
      {/* Navegación y Progreso */}
      <nav className="fixed top-20 left-0 right-0 z-30 bg-white/80 backdrop-blur-md border-b border-slate-50 py-4 px-6">
        <div className="max-w-3xl mx-auto flex justify-between items-center">
          <Link to="/blog" className="flex items-center gap-2 text-slate-400 hover:text-slate-900 transition-colors group">
            <ChevronLeft size={16} className="group-hover:-translate-x-1 transition-transform" />
            <span className="text-[10px] font-bold uppercase tracking-widest">Editorial</span>
          </Link>
          <button className="text-slate-400 hover:text-blue-600 transition-colors">
            <Share2 size={16} />
          </button>
        </div>
      </nav>

      {/* Hero del Post */}
      <header className="pt-48 pb-16 px-6 text-center">
        <div className="max-w-3xl mx-auto space-y-6">
          <span className="text-blue-600 text-[10px] font-black uppercase tracking-[0.4em] block">
            Arquitectura & Estilo
          </span>
          <h1 className="text-4xl md:text-6xl font-serif text-slate-900 leading-tight">
            {post.title}
          </h1>
          <div className="flex items-center justify-center gap-6 pt-8 text-slate-400 text-[10px] font-bold uppercase tracking-widest">
            <div className="flex items-center gap-2">
              <Calendar size={14} />
              <span>{new Date(post.created_at).toLocaleDateString('es-ES', { day: 'numeric', month: 'long', year: 'numeric' })}</span>
            </div>
            <div className="w-1 h-1 bg-slate-200 rounded-full" />
            <div className="flex items-center gap-2">
              <User size={14} />
              <span>VEstates Editorial Team</span>
            </div>
          </div>
        </div>
      </header>

      {/* Imagen Principal Artística */}
      <div className="max-w-5xl mx-auto px-6 mb-20">
        <div className="aspect-[21/9] rounded-[40px] overflow-hidden bg-slate-100 shadow-2xl shadow-slate-200">
          <img 
            src={post.image || "https://images.unsplash.com/photo-1600607687940-c52af0843942?auto=format&fit=crop&q=80&w=2000"} 
            className="w-full h-full object-cover"
            alt={post.title}
          />
        </div>
      </div>

      {/* Contenido del Artículo */}
      <div className="max-w-3xl mx-auto px-6">
        <div 
          className="prose prose-slate prose-lg lg:prose-xl max-w-none 
            prose-headings:font-serif prose-headings:italic prose-headings:font-normal
            prose-p:text-slate-600 prose-p:leading-relaxed prose-p:font-light
            prose-blockquote:border-l-blue-600 prose-blockquote:font-serif prose-blockquote:italic
            prose-img:rounded-[32px] prose-img:shadow-lg"
          dangerouslySetInnerHTML={{ __html: post.content }} 
        />
        
        {/* Footer del Post */}
        <footer className="mt-20 pt-10 border-t border-slate-100">
          <div className="bg-slate-50 rounded-[32px] p-10 flex flex-col md:flex-row items-center gap-8">
            <div className="w-20 h-20 rounded-full bg-slate-200 overflow-hidden shrink-0">
               <img src="https://ui-avatars.com/api/?name=V+Estates&background=0f172a&color=fff" alt="Author" />
            </div>
            <div className="text-center md:text-left">
              <h4 className="font-serif text-xl mb-2">Escrito por VEstates Editorial</h4>
              <p className="text-slate-500 text-sm font-light leading-relaxed">
                Nuestros expertos curan las mejores historias sobre el mercado inmobiliario de alta gama y diseño contemporáneo.
              </p>
            </div>
          </div>
        </footer>
      </div>
    </article>
  );
}

export default BlogPost;